<script>
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import axios from "axios";
import Swal from "sweetalert2";

import {
  required
} from "vuelidate/lib/validators";
import {
  authFackMethods
} from "@/state/helpers";

export default {
  page: {
    title: "Categories",
    meta: [
      {
        name: "Categories",
      },
    ],
  },
  components: { Layout, PageHeader },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      isMinneapolis: false,
      categoryId:'',
      preservePage: 1,
      pageLimit:50,
      modalTitle:'',
      searchBy:'',
      status: [{ value:'active',text:'Active'},{value:'inactive',text:'InActive'}],
      types: [{ value:'4',text:'Volunteer'},{value:'3',text:'Mentor'}],
      locations: null,
      categories:{},
      currentUserData : JSON.parse(localStorage.getItem('user')),
      categoryForm: {
        name: "",
        description: "",
        status: null,
        location_id: null,
        user_type_id: null
      },
      categorysubmit: false,
      searchForm: {
        name: null,
        user_type_id: null,
        status: null,
        location: null,
      },
      isUpdate: false,
      isAdd: false,
      isName: false,
      isUserType: false,
      isLocation: false,
      isStatus: false,
      isSearching: false,
      isLoading:false,
      noRecord: false,
    }
  },
  validations: {
    categoryForm: {
      name: { required },
      description: { required },
      status: { required },
      location_id: { required },
      user_type_id: { required }
    },
  },
  mounted(){
    this.getCategories();
  },
  methods: {

    containsMinneapolis(locationIds=[]) {
        const minneapolis = 2;
        return locationIds.indexOf(minneapolis) > -1;
    },

    getCategories(page){

      if( this.currentUserData['user_type_id'] == 10 ) {
        if( this.containsMinneapolis(this.currentUserData['locations']) ) {
          this.isMinneapolis = true;
        } else {
          this.isMinneapolis = false;
        }
      }

      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined'){
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page='+ this.pageLimit;
      if (this.searchForm.name){
        filter += '&name='+ this.searchForm.name
      }
      if (this.searchForm.user_type_id){
        filter += '&user_type_id='+ this.searchForm.user_type_id
      }
      if( this.currentUserData['user_type_id'] != 10 ) {
        if (this.searchForm.location){
          filter += '&location='+ this.searchForm.location
        }
      }
      if (this.searchForm.status){
        filter += '&status='+ this.searchForm.status
      }
      if( this.currentUserData['user_type_id'] == 10 ) {
        filter += '&location_id='+ this.currentUserData['locations'].join(',')
      }
      axios.get('categories?pagination=true&page='+ page + filter).then(res =>{
        this.categories = res.data.response;
        this.isLoading = false;
        if (!this.categories.data.length){
          this.noRecord = true;
          if (page > 1){
            this.locations(page-1);
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },
    ...authFackMethods,

    showAddModal() {
      this.modalTitle = 'Add Category'
      this.$bvModal.show('categoryModal');
      this.isAdd = true;
      this.isUpdate = false;
      this.getLocations();
      this.emptyCategoryFields();
    },

    showEditModal(category) {
      this.getLocations();
      this.modalTitle = 'Edit Category'
      this.$bvModal.show('categoryModal');
      this.categoryForm.name = category.name;
      this.categoryForm.description = category.description;
      this.categoryForm.status = category.status;
      this.categoryForm.location_id = category.location_id;
      this.categoryForm.user_type_id = category.user_type_id;
      this.categoryId = category.id;
      this.isUpdate = true;
      this.isAdd = false;
    },

    deleteCategory(category) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          var token = localStorage.getItem('token');
          var config = {
            headers: {
              Authorization: 'Bearer ' + token,
              'Accept': 'application/json'
            }
          };
          if (token) {
            axios.delete('categories/'+category.id, config)
                .then((res) => {
                  if (res.status == '200'){
                    Swal.fire({
                      title: "Deleted!",
                      text: category.name + " has been deleted!",
                      icon: "success",
                      width: 350,
                      showConfirmButton: false,
                      timer: 1500
                    });
                    this.getCategories(this.preservePage);
                  }
                })
                .catch((err) => {
                  if (err.response) {
                    Swal.fire({
                      title: "Error!",
                      text: err.response.data.error.message,
                      icon: "danger",
                      width: 350,
                      showConfirmButton: true
                    });
                  }
                })
          }
        }
      });
    },

    getLocations(){
      axios.get('admin/locations').then(res =>{
        this.locations = res.data.response;
      })
    },

    emptyCategoryFields(){
      this.categoryForm = {
        name: "",
        description: "",
        status: null,
        location_id: null,
        user_type_id: null
      };
    },

    saveCategory() {
      this.categorysubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('categories', this.categoryForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Success!",
                    text:"Category added successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getCategories();
                  this.emptyCategoryFields();
                  this.$bvModal.hide('categoryModal');
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                  if (err.response.status == 401) {
                    this.logOut();
                  }
                }
              })
        }
      }

    },

    updateCategory() {
      this.categorysubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.patch('categories/'+this.categoryId, this.categoryForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Success!",
                    text:"Category updated successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getCategories();
                  this.emptyCategoryFields();
                  this.$bvModal.hide('categoryModal');
                  this.categorysubmit = false;
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                  if (err.response.status == 401) {
                    this.logOut();
                  }
                }
              })
        }
      }

    },

    searchOption(event){
      this.searchForm = {
        name: null,
        user_type_id: null,
        status: null,
        location: null,
      };
      let selectedValue = event.target.value
      if (selectedValue == ''){
        this.resetSearch();
      }
      if (selectedValue == 'name') {
        this.isName = true;
        this.isUserType = false;
        this.isLocation = false;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'user_type_id') {
        this.isName = false;
        this.isUserType = true;
        this.isLocation = false;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'location') {
        this.getLocations();
        this.isName = false;
        this.isUserType = false;
        this.isLocation = true;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'status') {
        this.isName = false;
        this.isUserType = false;
        this.isLocation = false;
        this.isStatus = true;
        this.isSearching = true;
      }
    },

    searchCategories(){
      this.getCategories();
    },

    resetSearch(){
      this.searchForm = {
        name: null,
        user_type_id: null,
        status: null,
        location: null,
      };
      this.isName = false;
      this.isSearching = false;
      this.isUserType = false;
      this.isLocation = false;
      this.isStatus = false;
      this.searchBy ='';
      this.getCategories();
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Categories</h5>
          </div>

          <div class="mb-4 mdl-btns ms-auto">

            <!--Add Category Modal-->
            <b-button  @click="showAddModal" variant="primary">Add Category</b-button>
            <b-modal
                id="categoryModal"
                centered
                :title="modalTitle"
                title-class="font-18"
                hide-footer
            >
              <form>

                <div class="mb-3">
                  <label>Category</label>
                  <input
                      v-model="categoryForm.name"
                      type="text"
                      class="form-control"
                      placeholder="Enter Category Name"
                      name="name"
                      :class="{
                    'is-invalid': categorysubmit && $v.categoryForm.name.$error,
                  }"
                  />
                  <div
                      v-if="categorysubmit && $v.categoryForm.name.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.categoryForm.name.required"
                  >Category name is required.</span
                  >
                  </div>
                </div>

                <div class="mb-3">
                  <label>Description</label>
                  <div>
                  <textarea
                      v-model="categoryForm.description"
                      class="form-control"
                      name="description"
                      :class="{
                      'is-invalid': categorysubmit && $v.categoryForm.description.$error,
                    }"
                      rows="3" placeholder="Enter Description"
                  ></textarea>
                    <div
                        v-if="categorysubmit && $v.categoryForm.description.$error"
                        class="invalid-feedback"
                    >
                    <span v-if="!$v.categoryForm.description.required"
                    >Description is required.</span
                    >
                    </div>
                  </div>
                </div>

                <div class="mb-3">

                  <label class="mt-0">Select Status</label>
                  <b-form-select class="form-select" v-model="categoryForm.status" :options="status"
                                 :class="{'is-invalid': categorysubmit && $v.categoryForm.status.$error,}"
                  >
                    <option slot="first" :value="null" disabled>Select Status</option>
                  </b-form-select>
                  <div
                      v-if="categorysubmit && $v.categoryForm.status.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.categoryForm.status.required"
                  >Status is required.</span>
                  </div>

                </div>

                <div class="mb-3">

                  <label class="mt-0">Select Location</label>
                  <b-form-select class="form-select" v-model="categoryForm.location_id" :options="locations"
                                 value-field="id"
                                 text-field="name"
                                 :class="{'is-invalid': categorysubmit && $v.categoryForm.location_id.$error,}"
                  >
                    <option slot="first" :value="null" disabled>Select Location</option>
                  </b-form-select>
                  <div
                      v-if="categorysubmit && $v.categoryForm.location_id.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.categoryForm.location_id.required"
                  >Location is required.</span>
                  </div>

                </div>

                <div class="mb-3">

                  <label class="mt-0">Select User Type</label>
                  <b-form-select class="form-select" v-model="categoryForm.user_type_id" :options="types"
                                 :class="{'is-invalid': categorysubmit && $v.categoryForm.user_type_id.$error,}"
                  >
                    <option slot="first" :value="null" disabled>Select Type</option>
                  </b-form-select>
                  <div
                      v-if="categorysubmit && $v.categoryForm.user_type_id.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.categoryForm.user_type_id.required"
                  >User Type is required.</span>
                  </div>

                </div>

                <div class="mb-0">
                  <div>
                    <button type="button" v-if="isAdd" @click="saveCategory" class="btn btn-primary">Add Category</button>
                    <button type="button" v-if="isUpdate" @click="updateCategory" class="btn btn-primary">Update Category</button>
                  </div>
                </div>

              </form>
            </b-modal>

          </div>

        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
                class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
              <option value="">Select Option</option>
              <option value="name">Category Name</option>
              <option value="user_type_id">User Type</option>
              <option v-if="currentUserData['user_type_id'] != 10" value="location">Location</option>
              <option value="status">Status</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                  v-model="searchForm.name"
                  type="text"
                  class="ps-4 form-control"
                  placeholder="Type Category"
              />
                <input v-if="isLocation"
                       v-model="searchForm.location"
                       type="text"
                       class="ps-4 form-control"
                       placeholder="Type Location"
                />
                <b-form-select v-if="isUserType" class="form-select" v-model="searchForm.user_type_id" :options="types">
                  <option slot="first" :value="null" disabled>Select User Type</option>
                </b-form-select>

                <b-form-select v-if="isStatus" class="form-select" v-model="searchForm.status" :options="status">
                <option slot="first" :value="null" disabled>Select Status</option>
              </b-form-select>
                <b-button v-if="isSearching" id="show-btn" class="btn-find" @click="searchCategories" variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                          variant="primary" title="Reset">
                  <i class="bx bx-reset"> Reset</i>
                </b-button>
              </div>
            </div>
          </div>
        </form>


        <div class="table-responsive ">
          <table class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0">

            <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Description</th>
              <th scope="col">Location</th>
              <th scope="col">User Type</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="noRecord">
              <td colspan="6" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>

            <tr v-if="isLoading">
              <td colspan="6" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>

            <tr v-else v-for="(category, index) in categories.data" :key="index">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{category.name}}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1 text-capitalize">
                  {{category.status}}
                </h5>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap">
                  {{category.description.substr(0, 50) + '...'}}
                </p>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap">
                  {{category.location ? category.location.name : '-'}}
                </p>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap text-capitalize">
                  {{category.UserType}}
                </p>
              </td>
              <td class="text-center">
                <b-button id="show-btn" @click="showEditModal(category)" variant="primary" title="Edit">
                  <i class="bx bx-pencil"></i>
                </b-button>
                <b-button @click="deleteCategory(category)" class="ms-2" variant="danger" title="Delete">
                  <i class="bx bx-trash"></i>
                </b-button>
              </td>

            </tr>

            </tbody>
          </table>
        </div>

        <pagination class="mt-4" :data="categories" :limit="10" @pagination-change-page="getCategories"></pagination>

      </div>
    </div>

  </Layout>
</template>
<style scoped>
.mdl-btns button:nth-child(1){
  margin-right:1rem;
}
.app-search input, .app-search select{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.app-search .btn-find{
  width: 40%;
  border-top-right-radius:30px;
  border-bottom-right-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow:none;
}
.app-search .btn-reset{
  width: 40%;
  font-size: 15px;
  box-shadow:none;
  border-radius:30px;
}
</style>
